import { Injectable } from '@angular/core';
import { API_URL } from '../../../../../services/config';
import { ShipmentTransportOrderEndpoint } from '../../constants';
import { TransportOrderIdView } from '../../../../models';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { getQueryStringFromObject } from '../../../../../common/utils';
import { Observable } from 'rxjs';
import { ShipmentTransportOrderLoadModel } from '../../models/shipment-transport-order-load.model';

@Injectable({ providedIn: 'root' })
export class ShipmentTransportOrderLoadsService {
  constructor(private http: WrapperHttpService) {}

  getShipmentTransportOrderLoads(params: TransportOrderIdView): Observable<ShipmentTransportOrderLoadModel[]> {
    return this.http
      .withLoading()
      .get<ShipmentTransportOrderLoadModel[]>(
        `${API_URL}${ShipmentTransportOrderEndpoint.Base}${ShipmentTransportOrderEndpoint.Tos}${
          ShipmentTransportOrderEndpoint.Loads
        }?${getQueryStringFromObject(params)}`,
      );
  }
}
